export enum InstantFlightType {
  DIRECT_FLIGHT = "DIRECT_FLIGHT",
  AIR_AMBULANCE = "AIR_AMBULANCE",
  TECH_HALT = "TECH_HALT"
}